import axios from './api';
import { getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/workEmissions';

const getWorkEmissionsUpdates = ({ month, year }, project) =>
  axios.get(endPoint.concat(`?month=${month}&year=${year}&project=${project}`));

const getWorkEmissionsFirstDate = (projectId) => {
  return axios.get(endPoint.concat(`/first-date?project=${projectId}`));
};

const downloadXlsx = (project, concreteType) =>
  axios.get(
    endPoint.concat(
      `/download?project=${project}&concreteType=${concreteType}`,
    ),
    {
      responseType: 'blob',
    },
  );

export { getWorkEmissionsUpdates, downloadXlsx, getWorkEmissionsFirstDate };
